<template>
  <div>
    <button v-if="!controlerBtnSubmit" class="btn btn-primary" v-on:click="downloadAnexo()" href="javascript:void(0)">Preventivas</button>
    <button v-else type="button" class="btn btn-primary" disabled><i class='fa fa-refresh fa-spin'></i> Carregando...</button><br>
  </div> 
</template>

<script>
import modalFechamentoFixoVariavel from '../../modal/FechamentoFixoVariavel.vue'

export default {
  data () {
    return {
      env: process.env,
      controlerBtnSubmit: false
    }
  },
  components: {
    'modal-fechamento-fixo-variavel': modalFechamentoFixoVariavel
  },
  mounted: function () {
  },
  methods: {
    abrirModal () {
      this.$store.commit('setModalFechamentoFixoVariavel', {show: true})
    },
    downloadAnexo (mesAno) {
      this.controlerBtnSubmit = true
      let vm = this
      let payload = {
        estado: this.$store.state.login.loginUsuario.estado
      }
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getRelatorioSemanalPreventivas`, payload, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          let arquivoDownload = response.data.arquivo_download

          // Redirecionar a janela atual para o link de download.
          // Obs.: Remove o final 'api' do env.FINANCEIRO.SLA, pois, a rota é web.
          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload

          setTimeout(() => {
            vm.controlerBtnSubmit = false
          }, 10000)
        } else {
          vm.$store.commit('setAlert', {msg: response.data.erro, status: false, show: true})
          vm.controlerBtnSubmit = false
        }
      }).catch(() => {
        this.controlerBtnSubmit = false
      })
      console.log(payload)
    }
  }
}
</script>

<style scoped>
  button:hover {
    background-color: #6c757d;
  }
    /* button {
    background-color:#3c7fe4;
    color: white;
    margin: 1%;
    margin-right: 5px;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:5px;
    padding-top:5px;
    border-style: none;
    border-radius: 5px;
    width: 160px;
    height: 50px;
  } */

</style>



// WEBPACK FOOTER //
// ExportRelatorioSemanalPreventivas.vue?3229e58a